<template>
    <div class="calc-card" :class="{ 'calc-card--wide': wide }">
        <div v-if="step" class="calc-card__step">{{ $t(step) }}</div>
        <h1 v-if="title" class="calc-card__title">{{ $t(title) }}</h1>
        <p v-if="subtitle" class="calc-card__subtitle">{{ $t(subtitle) }}</p>
        <slot />
    </div>
</template>

<script>
export default {
    name: 'CalcCard',

    props: {
        wide: {
            type: Boolean,
            default: false,
        },
        step: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
    },
}
</script>

<style scoped>
.calc-card {
    width: 100%;
    max-width: var(--calc-card-w);
    background: white;
    border-radius: 16px;
    padding: 53.7px 79px 53.7px 79px;
    position: relative;
}

.calc-card--wide {
    max-width: var(--calc-card-w-wide);
    padding: 53.7px 99px;
}

.calc-card__step {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.1em;
    color: var(--calc-ink);
    opacity: 0.5;
    text-transform: uppercase;
    font-weight: 400;
}

.calc-card__title {
    margin: 8px 0 8px;
    font-family: 'TWK Lausanne', 'Inter', sans-serif;
    font-size: 40px;
    line-height: 50px;
    letter-spacing: -0.02em;
    color: var(--calc-ink);
    font-weight: 400;
}

.calc-card__subtitle {
    font-size: 16px;
    line-height: 100%;
    color: var(--calc-ink);
    opacity: 0.5;
    margin: 0 0 38px;
}

@media (max-width: 760px) {
    .calc-card {
        padding: 28px 22px;
        border-radius: 16px;
    }
    .calc-card--wide {
        padding: 28px 22px;
    }
    .calc-card__title {
        font-size: 32px;
        line-height: 1.15;
    }
    .calc-card__subtitle {
        margin-bottom: 26px;
        font-size: 15px;
    }
}
</style>
